export const CONNECTION_TYPES = {
  NONE: 0,
  AUTO: 1,
  MANUAL: 2,
} as const
